module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('h2', {
    staticClass: "h2a"
  }, [_c('a', {
    attrs: {
      "id": "page_4"
    }
  }, [_vm._v("Persons Represented")])]), _c('a', {
    attrs: {
      "id": "page_4"
    }
  }, [_c('p', {
    staticClass: "noindent"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("KING EDWARD THE FOURTH")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_vm._v("Sons to the king")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("EDWARD, PRINCE OF WALES")])]), _vm._v(" "), _c('p', {
    staticClass: "noindenti"
  }, [_vm._v("Afterwards "), _c('span', {
    staticClass: "bold"
  }, [_vm._v("KING EDWARD V")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("RICHARD, DUKE OF YORK")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_vm._v("Brothers to the king")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("GEORGE, DUKE OF CLARENCE")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("RICHARD, DUKE OF GLOSTER,")])]), _vm._v(" "), _c('p', {
    staticClass: "noindenti"
  }, [_vm._v("Afterwards "), _c('span', {
    staticClass: "bold"
  }, [_vm._v("KING RICHARD III")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("A YOUNG SON OF CLARENCE")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("HENRY, EARL OF RICHMOND,")]), _vm._v(" "), _c('p', {
    staticClass: "noindenti"
  }, [_vm._v("Afterwards "), _c('span', {
    staticClass: "bold"
  }, [_vm._v("KING HENRY VII")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("CARDINAL BOURCHIER, ARCHBISHOP OF CANTERBURY")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("THOMAS ROTHERHAM, ARCHBISHOP OF YORK")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("JOHN MORTON, BISHOP OF ELY")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("DUKE OF BUCKINGHAM")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("DUKE OF NORFOLK")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("EARL OF SURREY")]), _vm._v(", his son")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("EARL RIVERS")]), _vm._v(", brother to King Edward’s Queen")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("MARQUIS OF DORSET")]), _vm._v(" and "), _c('span', {
    staticClass: "bold"
  }, [_vm._v("LORD GREY")]), _vm._v(", her sons")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("EARL OF OXFORD")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("LORD HASTINGS")])])]), _c('p', {
    staticClass: "noindent"
  }, [_c('a', {
    attrs: {
      "id": "page_4"
    }
  }, [_c('span', {
    staticClass: "bold"
  })]), _c('a', {
    attrs: {
      "id": "page_5"
    }
  }, [_vm._v("LORD STANLEY")])]), _c('a', {
    attrs: {
      "id": "page_5"
    }
  }, [_c('p', {
    staticClass: "noindent"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("LORD LOVEL")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("SIR THOMAS VAUGHAN")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("SIR RICHARD RATCLIFF")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("SIR WILLIAM CATESBY")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("SIR JAMES TYRREL")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("SIR JAMES BLOUNT")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("SIR WALTER HERBERT")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("SIR ROBERT BRAKENBURY")]), _vm._v(", Lieutenant of the Tower")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("CHRISTOPHER URSWICK")]), _vm._v(", a priest")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("Another Priest")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("LORD MAYOR OF LONDON")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("SHERIFF OF WILTSHIRE")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("ELIZABETH")]), _vm._v(", Queen to King Edward IV")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("MARGARET")]), _vm._v(", widow to King Henry VI")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("DUCHESS OF YORK")]), _vm._v(", mother to King Edward IV, Clarence, and Gloster")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("LADY ANNE")]), _vm._v(", widow to Edward, Prince of Wales, son to King Henry VI; afterwards married to the Duke of Gloster")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("A YOUNG DAUGHTER OF CLARENCE")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_vm._v("Lords, and other Attendants; two Gentlemen, a Pursuivant, Scrivener, Citizens, Murderers, Messengers, Ghosts, Soldiers, &c.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Scene: England")])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-50e3c03f","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/02_Persons.vue
// module id = 69
// module chunks = 0